module.exports = __webpack_public_path__ + "img/MY.537daaa3.svg";